/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { setActiveTrace } from '@atlaskit/react-ufo/experience-trace-id-context';
import type { MetaTagGetter } from './types.tsx';

let alreadySet = false;

export const retrieveAndSetPageLoadTrace = (getMeta: MetaTagGetter): void => {
	if (__SERVER__ || alreadySet) return;
	alreadySet = true;

	const traceId = getMeta('X-B3-TraceId');

	// Only set active trace if a valid trace ID exists
	if (!traceId) return;

	const spanId = traceId.substring(traceId.length - 16); // set root span ID by convention

	setActiveTrace(traceId, spanId, 'page_load');
};
